import { Pencil, Trash2, Type, Hash, Mail, Calendar, ToggleRight, AlertCircle } from 'lucide-react';
import { JsonField } from './JsonFieldBuilder';
import styles from './JsonFieldBuilder.module.css';

interface FieldCardProps {
    field: JsonField;
    onEdit: () => void;
    onDelete: () => void;
}

const getFieldIcon = (tipo: JsonField['tipo']) => {
    const iconProps = { size: 18, strokeWidth: 2 };
    switch (tipo) {
        case 'string': return <Type {...iconProps} />;
        case 'number': return <Hash {...iconProps} />;
        case 'email': return <Mail {...iconProps} />;
        case 'date': return <Calendar {...iconProps} />;
        case 'boolean': return <ToggleRight {...iconProps} />;
        default: return <AlertCircle {...iconProps} />;
    }
};

const getFieldTypeLabel = (tipo: JsonField['tipo']): string => {
    switch (tipo) {
        case 'string': return 'Texto';
        case 'number': return 'Número';
        case 'email': return 'Email';
        case 'date': return 'Fecha';
        case 'boolean': return 'Sí/No';
        default: return tipo;
    }
};

export const FieldCard = ({ field, onEdit, onDelete }: FieldCardProps) => {
    return (
        <div className={styles.fieldCard}>
            <div className={styles.fieldHeader}>
                <div className={styles.fieldTitle}>
                    <span className={styles.fieldIcon}>{getFieldIcon(field.tipo)}</span>
                    <span className={styles.fieldName}>{field.nombre}</span>
                    <span className={styles.fieldType}>({getFieldTypeLabel(field.tipo)})</span>
                    {field.requerido && (
                        <span className={styles.requiredBadge}>*REQUERIDO*</span>
                    )}
                </div>
                <div className={styles.fieldActions}>
                    <button
                        type="button"
                        className={`${styles.iconBtn} ${styles.editFieldButton}`}
                        onClick={onEdit}
                        title="Editar campo"
                        aria-label={`Editar campo ${field.nombre}`}
                    >
                        <Pencil size={16} strokeWidth={2.5} />
                    </button>
                    <button
                        type="button"
                        className={`${styles.iconBtn} ${styles.deleteFieldButton}`}
                        onClick={onDelete}
                        title="Eliminar campo"
                        aria-label={`Eliminar campo ${field.nombre}`}
                    >
                        <Trash2 size={16} strokeWidth={2.5} />
                    </button>
                </div>
            </div>

            {field.descripcion && (
                <div className={styles.fieldDescription}>{field.descripcion}</div>
            )}

            <div className={styles.fieldMeta}>
                {field.longitudMaxima && (
                    <span className={styles.metaItem}>
                        Long. máx: {field.longitudMaxima}
                    </span>
                )}
                {field.mensajeError && (
                    <span className={styles.metaItem}>
                        <AlertCircle size={14} strokeWidth={2} style={{ display: 'inline', marginRight: '4px' }} />
                        {field.mensajeError}
                    </span>
                )}
            </div>
        </div>
    );
};
